var TimeFormatOptions = /* @__PURE__ */ ((TimeFormatOptions2) => {
  TimeFormatOptions2[TimeFormatOptions2["TIME_FORMAT_24"] = 1] = "TIME_FORMAT_24";
  TimeFormatOptions2[TimeFormatOptions2["TIME_FORMAT_12"] = 2] = "TIME_FORMAT_12";
  return TimeFormatOptions2;
})(TimeFormatOptions || {});
var DateSettings = /* @__PURE__ */ ((DateSettings2) => {
  DateSettings2[DateSettings2["transactionHistoryAgo"] = -30] = "transactionHistoryAgo";
  DateSettings2[DateSettings2["transactionHistoryAgoMax"] = -90] = "transactionHistoryAgoMax";
  return DateSettings2;
})(DateSettings || {});
const BASE_TIMEZONE = "UTC";
const BASE_LOCALE = "en-US";
const ISO_FORMAT = "YYYY-MM-DD'T'HH:mm:ss.sss Z";
const DateSettingsFormat = {
  pickerDateTime: "YYYY-MM-DD HH:mm:ss",
  dateTimeString: "YYYY-MM-DD HH:mm:ss",
  pickerDateTimeShort: "YYYY-MM-DD HH:mm",
  dateTimeStringShort: "YYYY-MM-DD HH:mm",
  pickerDate: "yyyy-MM-dd",
  dateFnsDate: "YYYY-MM-DD",
  timeShort: "HH:mm",
  time: "HH:mm:ss",
  dateFnsTimestamp: "x",
  cabinetDate: "dd.MM.yyyy",
  onlyMonth: "MM",
  onlyDay: "DD",
  onlyYear: "YYYY",
  localDateTime: "DD:MM:YYYY HH:mm:ss"
};
const CabinetDateSetting = {
  onlyTimeZone: "Z",
  onlyDate: "DD.MM.YYYY",
  onlyTime: (format = 1, isTimeWithSecond) => {
    if (isTimeWithSecond) {
      return format === 1 ? "HH:mm:ss" : "hh:mm:ss a";
    }
    return format === 1 ? "HH:mm" : "hh:mm a";
  },
  dateTimeLong: (timeFormat = 1) => `DD MMM YYYY, ${timeFormat === 1 ? "HH:mm" : "hh:mm a"}`,
  historyTransactionDate: () => {
    const date = /* @__PURE__ */ new Date();
    date.setDate(
      date.getDate() + -30
      /* transactionHistoryAgo */
    );
    return date;
  },
  historyTransactionMinDate: () => {
    const date = /* @__PURE__ */ new Date();
    date.setDate(
      date.getDate() + -90
      /* transactionHistoryAgoMax */
    );
    return date;
  }
};
const YEARS_AMOUNT = 100;
export {
  BASE_LOCALE,
  BASE_TIMEZONE,
  CabinetDateSetting,
  DateSettings,
  DateSettingsFormat,
  ISO_FORMAT,
  TimeFormatOptions,
  YEARS_AMOUNT
};
